import React from 'react';
import {connect} from "react-redux";

let payments = [
    {
        id: 1,
        key: 'Online',
        active: false
    },
    {
        id: 2,
        key: 'Offline',
        active: true
    }
];

class Payments extends React.Component {
    constructor(props) {
        super(props);

        const {locale} = props;
        const {abbreviation} = locale;
        const isIran = abbreviation == 'fa-IR';

        payments.find(x => x.key.toLowerCase() == 'online').active = isIran;

        const data = payments.filter(x => x.active);
        const selected = data[0].id;

        this.state = {
            selected,
            data
        };

        this._onChange(selected)
    }

    _onChange = (selected) => {
        const {data} = this.state;
        this.setState({selected});

        const {onChange} = this.props;
        const sData = data.find(x => x.id == selected);
        onChange(sData);
    };

    render() {
        const {data, selected} = this.state;

        const {locale} = this.props;
        const pageTranslates = locale.translation.Components.Payments;

        const {abbreviation} = locale;
        const isIran = abbreviation == 'fa-IR';

        const borderStyle = {
            borderRadius: 15,
            borderStyle: 'solid',
            borderWidth: 1,
            borderColor: 'gray'
        };
        const selectedStyle = {
            borderColor: 'green',
            borderWidth: 2
        };

        return (
            <div className='col-12'>
                <h3 className='color-primary mt-3 mb-3'>
                    {pageTranslates.Title}
                </h3>
                {data.map(({id, key}) => {
                    const isSelected = id == selected;
                    const style = {...borderStyle};
                    if (isSelected)
                        Object.assign(style, selectedStyle);

                    const {Title, Description} = pageTranslates[key];

                    return (
                        <div className='row mt-2 mb-2 p-2' style={style} onClick={this._onChange.bind(this, id)}>
                            <div className='col-10'>
                                <h5>
                                    {Title}
                                </h5>
                                <small className='text-justify'>
                                    {Description}
                                </small>
                            </div>
                            <div className='col-2 d-flex justify-content-center align-items-center'>
                                {isSelected ?
                                    <i className='fa fa-check text-success'/>
                                    :
                                    <i className='fa fa-circle' style={{color: '#ccc'}}/>
                                }
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }
}

const mapStateToProps = state => {
    const {locale} = state;
    return {locale};
};

export default connect(mapStateToProps, null)(Payments);

